import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { isAdminToolSsoOnly, normalizeAdminToolSsoMode } from '@app/constants/enums/adminToolSsoMode';
import * as S from './ProfileOverlay.styles';

interface IProps {
  showNetList?: boolean;
  onNetListClick?: () => void;
}

export const ProfileOverlay: React.FC<IProps> = ({ showNetList, onNetListClick, ...props }) => {
  const { t } = useTranslation();
  const { currentCanton } = useAppSelector((state) => state.config);
  const showChangePassword = !isAdminToolSsoOnly(normalizeAdminToolSsoMode(currentCanton?.adminToolSsoEnabled));

  return (
    <div {...props}>
      <S.Text>
        <Link to="/profile">{t('profile.title')}</Link>
      </S.Text>
      {showChangePassword && (
        <S.Text>
          <Link to="/change-password">{t('profile.changePassword')}</Link>
        </S.Text>
      )}
      {showNetList && (
        <S.Text>
          <S.MenuButton type="button" onClick={onNetListClick}>
            {t('professionalFishers.netList')}
          </S.MenuButton>
        </S.Text>
      )}
      <S.ItemsDivider />
      <S.Text>
        <Link to="/logout">{t('header.logout')}</Link>
      </S.Text>
    </div>
  );
};
